import { useEffect, useState } from "react";

const DURATION_MS = (17 * 60 + 34) * 1000;
const START = Date.now();

function remainingSeconds() {
  const elapsed = (Date.now() - START) % DURATION_MS;
  return Math.ceil((DURATION_MS - elapsed) / 1000);
}

export function useCountdown() {
  const [secs, setSecs] = useState(remainingSeconds);

  useEffect(() => {
    const id = window.setInterval(() => setSecs(remainingSeconds()), 250);
    return () => window.clearInterval(id);
  }, []);

  const total = secs >= DURATION_MS / 1000 ? DURATION_MS / 1000 : secs;
  return {
    hours: Math.floor(total / 3600),
    minutes: Math.floor((total % 3600) / 60),
    seconds: total % 60,
  };
}
